import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { cn } from '../../lib/utils';
import CrewDashboard from './CrewDashboard';
import { CrewIdentityHeader, CrewIdentityViewActions } from './CrewIdentityHeader';
import { parseCrewRouteId } from './crewRouteId';
import { useCrewFile } from './useData';

const Detail: React.FC = () => {
  const { colors } = useTheme();
  const { id } = useParams<{ id: string }>();
  const crewId = parseCrewRouteId(id);
  const { data: item, isLoading } = useCrewFile(crewId);

  // DevTools / bad links can land on /crew/<non-numeric> — leave immediately.
  if (!crewId) {
    return <Navigate to="/crew/list" replace />;
  }

  if (isLoading) {
    return (
      <div className={cn('flex items-center justify-center flex-1 min-h-[240px] text-sm', colors.textMuted)}>
        Loading...
      </div>
    );
  }

  if (!item) {
    return (
      <div className={cn('flex items-center justify-center flex-1 min-h-[240px] text-sm', colors.textMuted)}>
        Crew file not found.
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col min-h-0 -mt-1">
      <CrewIdentityHeader
        item={item}
        fallbackPath="/crew"
        actions={<CrewIdentityViewActions crewId={item.id} />}
      />
      <div className="flex-1 min-h-0 overflow-y-auto dashboard-scrollbar pt-4">
        <CrewDashboard item={item} />
      </div>
    </div>
  );
};

export default Detail;
